<div class="aeReportList">
  <!-- Page Content -->
  <div class="text-center text-red mt-4" *ngIf="this.homeErrorMessages && !aeReportList">{{this.homeErrorMessages}}
  </div>
  <div class="row" *ngIf="userRole !== userLoginRole.PAP_SUPERVISOR && !isSuccessReportModal">
    <div class="col-10"></div>
    <div class="col-2 mt-4">
      <button class="btn btn-success cursor-pointer nav-link  fnt-size15px  align-items-center w-75 rounded"
        (click)="addPatientReport()">
        + {{'CREATE_PATIENT_REPORT' | translate}}
      </button>
      <dngx-model *ngIf="checkForDaichiiProcess() && isOpenEditMedicalDocumentForm"
        [displayModal]="isOpenEditMedicalDocumentForm" modalTitle="{{'CREATE_PATIENT_REPORT' | translate}}"
        [dismissableMask]="false" [headerVisible]="true" [closable]="true" [blockScroll]="false"
        (hideModal)="hideEditDocumentFormModal()">
        <div class="modal-content border-0">
          <form [formGroup]="patientReportForm" (submit)="onPatientReportSubmit()">
            <div class="pt-0 modal-body bg-white">
              <div class="row gap-1rem">
                <div class="col-md-12">
                  <p class="fnt-size12px text-black mb-1">{{'REPORT_TYPE' | translate}}<span
                      class="text-danger ml-1">*</span></p>
                  <p-dropdown class=" w-100 pr-2" [options]="reportTypeList" optionLabel="name"
                    (onChange)="setReportType($event)" formControlName="reportType" [placeholder]="'Select Type'"
                    [autoDisplayFirst]="false" panelStyleClass="bg-white border p-2 fnt-size12px dropdown-spaced-options"
                    styleClass="form-control fnt-size12px">
                  </p-dropdown>
                  <div *ngIf="showError && patientReportForm.get('reportType').errors" class="text-danger fnt-size12px">
                    {{ "REPORT_TYPE" | translate }} {{'IS_REQUIRED' | translate}}</div>
                </div>
                <div class="col-md-12">
                  <p class="text-black fnt-size12px mb-1">{{'INTERACTION_DATE' | translate}}<span
                      class="text-danger ml-1">*</span></p>
                  <p-calendar class="d-flex w-100  calendar-field" [showIcon]="true" [monthNavigator]="true"
                    [yearNavigator]="true" yearRange="1922:2030" [inline]="false"
                    panelStyleClass="bg-white border pap-patient-report-calender w-100"
                    formControlName="interactionDate" appendTo="body" [styleClass]="'pap-patient-report-calender'"
                    [inputStyleClass]="'form-control fnt-size12px fnt_Medium w-100'"
                    placeholder="{{'SELECT_INTERACTION_DATE' | translate}}" dateFormat="dd M yy" (onSelect)="onDateSelect('interactionDate', $event)">
                  </p-calendar>
                  <div *ngIf="showError && patientReportForm.get('interactionDate').errors"
                    class="text-danger fnt-size12px"> {{ "INTERACTION_DATE" | translate }} {{'IS_REQUIRED' | translate}}
                  </div>
                </div>
                <div class="col-md-12">
                  <label class="fnt-size12px">{{"INTERACTION_ID" | translate}} <span class="text-danger"></span></label>
                  <input type="text" formControlName="interactionId" class="form-control fnt-size14px" papAutoTrim
                    placeholder="{{'ENTER_INTERACTION_ID' | translate }} " />
                  <div
                    *ngIf="patientReportForm.get('interactionId').touched && patientReportForm.get('interactionId').errors?.required"
                    class="text-danger fnt-size12px"> {{ "INTERACTION_ID" | translate }} {{'IS_REQUIRED' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer bg-white">
              <button type="button" class="btn btn-outline border" (click)="hideEditDocumentFormModal()">{{'CANCEL' |
                translate}}</button>
              <button class="btn btn-success btn-loader" type="submit" (click)="onPatientReportSubmit()">
                <div class="d-flex align-items-center">
                  <ng-template #saveButton>{{'SAVE'| translate}}</ng-template>
                  <div class="spinner-border text-light ml-2" role="status" *ngIf="modalLoader; else saveButton;">
                  </div>
                </div>
              </button>
            </div>
          </form>
        </div>
      </dngx-model>
    </div>
  </div>
  <div class="page-content pt-4 pl-5 pr-5 pb-1 h-100 " id="content" *ngIf="aeReportList">
    <div class="h-100">
      <div class="row">
        <div class="col-6">
          <p class="pt-2 pb-2 fnt-size14px d-none d-lg-block">
            <span
              [ngClass]='{"active text-success border-bottom border-success font-weight-bold":activeTab === "PENDING"}'
              class="pt-2 pb-2 mr-4 text-secondary border-3 cursor-pointer" (click)="changeTab('PENDING')">{{'PENDING' |
              translate}}
              {{(activeTab === 'PENDING' && aeReportList?.data?.page?.totalCount)? '('+aeReportList.data.page.totalCount+')':''}}
            </span>
            <span
              [ngClass]='{"active text-success border-bottom border-success font-weight-bold":activeTab === "APPROVED"}'
              class="pt-2 pb-2  mr-4 text-secondary  border-3 cursor-pointer"
              (click)="changeTab('APPROVED')">{{'APPROVED' | translate}}
              {{(activeTab === 'APPROVED' && aeReportList?.data?.page?.totalCount)? '('+aeReportList.data.page.totalCount+')':''}}
            </span>
            <span
              [ngClass]='{"active text-success border-bottom border-success font-weight-bold":activeTab === "REJECTED"}'
              class="pt-2 pb-2  mr-4 text-secondary  border-3 cursor-pointer"
              (click)="changeTab('REJECTED')">{{'REJECTED' | translate}}
              {{(activeTab === 'REJECTED' && aeReportList?.data?.page?.totalCount)? '('+aeReportList.data.page.totalCount+')':''}}
            </span>
          </p>
        </div>
        <div class="col-6 userSearch mr-0">
          <div class="row">
            <div class="col-12">
              <span class="p-input-icon-left p-ml-auto position-relative w-100 userSearchInput">
                <i class="pi pi-search userSearchIcon"></i>
                <input class="w-100" pInputText type="text" [(ngModel)]="searchKeyword" (keyup)="searchData($event)"
                  placeholder="{{'SEARCH' | translate}}" />
              </span>
            </div>
            <div class="col-2 pl-0">
              <img [src]="filterAdded ? 'assets/images/search-filter-icon.svg' : 'assets/images/filter-white.svg'"
                alt="search filter" class="cursor-pointer" (click)="visibleFilter = true" />
            </div>
          </div>
        </div>
      </div>
      <div class="card recordList h-100 mt-3" style="max-height: calc( 100% - 56px );">
        <p-table [columns]="scrollableCols" [value]="hasListData ? aeReportList.data?.list : []" [scrollable]="true"
          frozenWidth="0px" scrollHeight="calc(100vh - 255px)" [rows]="10" [paginator]="false"
          [loading]="tableDataLoading">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th id="" *ngFor="let col of columns">
                {{col.header}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="text-left">{{'NO_RECORD_FOUND' | translate}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-customer let-columns="columns">
            <tr *ngIf="!hasListData">
              <td colspan="7" class="text-left">{{'NO_RECORD_FOUND' | translate}}</td>
            </tr>
            <tr *ngIf="hasListData" class="trBorder">
              <td class="font-weight-normal" *ngFor="let col of columns">
                <span *ngIf="col.field === 'id'">
                  {{customer?.id}}
                </span>
                <span *ngIf="col.field === 'doc'">
                  {{customer?.dateOfCreation * 1000 | date:'dd MMM yyyy, hh:mm a'}}
                </span>
                <span *ngIf="col.field === 'reportType'">
                  {{getReportType(customer?.reportType)}}
                </span>
                <span class="medium-font-weight" *ngIf="col.field === 'patient'">
                  {{customer?.patientId}}
                </span>
                <span *ngIf="col.field === 'program'">
                  {{customer?.programName}}
                </span>
                <p *ngIf="col.field === 'status'">
                  <span class="text-00B5D5 fnt_Medium bg-00B5D5-30 radius-20 px-2 py-1"
                    *ngIf="customer?.status === aeReportStatus.REVIEWED"> New </span>
                  <span class="text-E2B93B fnt_Medium" *ngIf="customer?.status === aeReportStatus.RE_REVIEW"> To be
                    reviewed by DCPM </span>
                  <span class="text-27AE60 fnt_Medium" *ngIf="customer?.status === aeReportStatus.APPROVED"> Approved
                  </span>
                  <span class="text-DC1313 fnt_Medium" *ngIf="customer?.status === aeReportStatus.REJECTED"> Rejected
                  </span>
                </p>
                <span *ngIf="col.field === 'action'">
                  <button (click)="navigateToAeReportDetail(customer?.id, customer?.status)"
                    class="btn btn-success fnt-size10px">{{'VIEW_DETAIL' | translate}}
                  </button>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div class="position-relative">
          <p-paginator [hidden]="tableDataLoading" #paginator
            *ngIf="aeReportList && aeReportList.data && hasListData && showPagination" [rows]="limit"
            [totalRecords]="aeReportList?.data?.page?.totalCount || 0" [alwaysShow]="false"
            (onPageChange)="setMyPagination($event)"
            [styleClass]="tableDataLoading ? 'pointer-events-none' : ''"></p-paginator>
        </div>
      </div>
    </div>
  </div>
  <dngx-model [displayModal]="isSuccessReportModal" [dismissableMask]="false" [headerVisible]="true" [closable]="true"
  (hideModal)= "redirectToHome()" contentStyleClass="rounded-bottom p-0">
  <div>
    <div class="pb-2 text-center fnt-size20px text-danger mt-2">
      <img src="../../../../assets/images/error-icon.svg" alt="">
    </div>
    <div class="text-center pb-4 pt-2 d-flex flex-column align-items-center">
      <span class="text-center fnt-size20px text-black font-weight-bold">{{'MODULE_NOT_AVAILABLE' | translate}}
      </span>
      <span class="text-center fnt-size14 text-black font-weight-regular mt-2 ">{{'MODULE_NOT_AVAILABLE_MESSAGE' | translate}}
      </span>
    </div>
  </div>
</dngx-model>
</div>